import { Button, styled } from "@mui/material";

export const CompanySelectButton = styled(Button)(
  ({ theme: { palette, spacing } }) => ({
    justifyContent: "space-between",
    padding: `${spacing(1.5)}`,
    fontSize: "1rem",
    fontWeight: 500,
    background: palette.main[800],
    minWidth: 0,

    "& .MuiTypography-root": {
      overflow: "hidden",
      whiteSpace: "nowrap",
      textOverflow: "ellipsis",
      color: palette.common.white,
    },

    "&:hover": {
      background: palette.main[700],
    },
  }),
);
